import React from 'react';

const awards = [
  {
    year: '2022',
    org: 'UC Berkeley',
    title: 'Berkeley Psychedelic Journalism Fellowship',
    institution: 'Ferris Psychedelic Fellowship, University of California, Berkeley',
  },
  {
    year: '2021',
    org: 'NYU',
    title: 'Diversity Reporting Award',
    institution: 'New York University',
  },
  {
    year: '2020',
    org: 'NYU',
    title: 'Falak Sufi Scholarship',
    institution: 'New York University',
  },
  {
    year: '2020',
    org: 'Caravan',
    title: 'Narrative Journalism Fellow',
    institution: 'Caravan Magazine',
  },
];

const Awards = () => (
  <section id="awards" className="bg-bg-primary px-10 py-10" style={{ borderBottom: '0.5px solid #e0ddd8' }}>
    <span className="section-label">Awards & Recognition</span>
    <div>
      {awards.map((award, i) => (
        <div
          key={i}
          className="flex gap-6 py-4 items-baseline"
          style={{ borderBottom: i < awards.length - 1 ? '0.5px solid #e0ddd8' : 'none' }}
        >
          <span
            className="text-terracotta font-inter flex-shrink-0"
            style={{ fontSize: '12px', minWidth: '36px' }}
          >
            {award.year}
          </span>
          <div>
            <p className="font-playfair text-ink" style={{ fontSize: '15px', lineHeight: 1.4, marginBottom: '3px' }}>
              {award.title}
            </p>
            <p className="text-muted font-inter" style={{ fontSize: '12px', fontStyle: 'italic' }}>
              {award.institution}
            </p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Awards;
